import { useState } from "react";

const TEMPLATES = [
  {
    id: "pack_sentinelle",
    nom: "Pack Sentinelle",
    type: "Vidéosurveillance",
    icon: "📷",
    color: "#5b6ef8",
    description: "Installation système de vidéosurveillance IP/HDCVI",
    sections: [
      { titre: "Informations client", champs: ["Raison sociale", "Adresse du siège", "Adresse du site", "Contact", "Téléphone"] },
      { titre: "Dossier", champs: ["N° dossier", "Date", "Technicien", "Observations"] },
      { titre: "Matériels Pack Sentinelle", champs: ["Liste des équipements + quantités (tableau)"] },
      { titre: "Fiche connexion vidéo", champs: ["SN du QR Code", "Identifiant", "Mot de passe"] },
      { titre: "Caméras (16 max)", champs: ["N° CAM", "Localisation", "IP", "HDCVI"] },
      { titre: "Questions installation", champs: ["NVR installé ?", "NVR fonctionnel ?", "Connexion Internet ?", "Relié à Dolynkcare ?", "Email client", "Résumé installation"] },
      { titre: "Formation client", champs: ["Formation facturée", "Formation assurée", "Système fonctionnel", "Satisfaction client"] },
      { titre: "Photos", champs: ["Photos obligatoires de l'installation"] },
      { titre: "Signatures", champs: ["Fait à", "Nom signataire", "Qualité", "Signature technicien", "Signature client"] },
    ]
  },
  {
    id: "pack_flash",
    nom: "Pack Flash Control",
    type: "Alarme intrusion",
    icon: "🚨",
    color: "#ef4444",
    description: "Installation système d'alarme intrusion",
    sections: [
      { titre: "Informations client", champs: ["Raison sociale", "Adresse du siège", "Adresse du site", "Contact", "Téléphone"] },
      { titre: "Dossier", champs: ["N° dossier", "Date", "Technicien", "Observations"] },
      { titre: "Matériels Pack Flash Control", champs: ["Liste des équipements + quantités (tableau)"] },
      { titre: "Centrale alarme", champs: ["Marque/Modèle", "Code installateur", "Code utilisateur", "Nb zones", "Téléassistance"] },
      { titre: "Zones configurées", champs: ["Zone", "Localisation", "Type détecteur", "Test OK"] },
      { titre: "Questions installation", champs: ["Système fonctionnel ?", "Zones testées ?", "Email client", "Résumé installation"] },
      { titre: "Formation client", champs: ["Formation facturée", "Formation assurée", "Client formé", "Satisfaction"] },
      { titre: "Photos", champs: ["Photos obligatoires de l'installation"] },
      { titre: "Signatures", champs: ["Fait à", "Nom signataire", "Qualité", "Signature technicien", "Signature client"] },
    ]
  },
  {
    id: "maintenance",
    nom: "Rapport de maintenance",
    type: "Maintenance préventive",
    icon: "🔧",
    color: "#22d3a0",
    description: "Rapport de visite de maintenance périodique",
    sections: [
      { titre: "Informations client", champs: ["Raison sociale", "Adresse", "Contact", "Téléphone"] },
      { titre: "Visite", champs: ["N° contrat", "Date visite", "Technicien", "Type maintenance"] },
      { titre: "Contrôles effectués", champs: ["État général système", "Nettoyage effectué", "Tests réalisés", "Anomalies constatées"] },
      { titre: "Matériel remplacé", champs: ["Désignation", "Référence", "Quantité"] },
      { titre: "Résumé & Préconisations", champs: ["Travaux effectués", "Préconisations", "Prochain entretien"] },
      { titre: "Photos", champs: ["Photos avant/après intervention"] },
      { titre: "Signatures", champs: ["Signature technicien", "Signature client"] },
    ]
  },
  {
    id: "depannage",
    nom: "Rapport de dépannage",
    type: "Intervention SAV",
    icon: "🛠️",
    color: "#f5a623",
    description: "Rapport d'intervention de dépannage et réparation",
    sections: [
      { titre: "Informations client", champs: ["Raison sociale", "Adresse", "Contact", "Téléphone"] },
      { titre: "Intervention", champs: ["N° ticket SAV", "Date", "Technicien", "Description panne signalée"] },
      { titre: "Diagnostic", champs: ["Cause de la panne", "Matériel défectueux", "Action corrective"] },
      { titre: "Matériel remplacé/utilisé", champs: ["Désignation", "Référence", "Quantité"] },
      { titre: "Tests & Vérifications", champs: ["Système testé", "Résultat", "Remarques"] },
      { titre: "Photos", champs: ["Photos du problème et de la solution"] },
      { titre: "Signatures", champs: ["Signature technicien", "Signature client"] },
    ]
  },
];

export default function ModelesPage({ T, onUseTemplate }) {
  const [selected, setSelected] = useState(null);
  const [view, setView] = useState("grid"); // grid | detail

  const openDetail = (tpl) => { setSelected(tpl); setView("detail"); };
  const back = () => { setView("grid"); setSelected(null); };

  return (
    <div style={{display:"flex",flexDirection:"column",gap:22}}>

      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:12}}>
        <div>
          {view==="detail" && (
            <button onClick={back} style={{background:"none",border:"none",color:T.accent,fontSize:13,fontWeight:600,cursor:"pointer",marginBottom:8,display:"flex",alignItems:"center",gap:6}}>
              ← Retour aux modèles
            </button>
          )}
          <div style={{fontSize:25,fontWeight:800,color:T.text,letterSpacing:"-0.7px"}}>📋 Modèles de PV</div>
          <div style={{fontSize:13,color:T.muted,marginTop:4}}>
            {view==="grid" ? `${TEMPLATES.length} modèles disponibles · Sélectionnez pour voir le détail` : selected?.nom}
          </div>
        </div>
        {view==="grid" && (
          <div style={{background:T.accentDim,border:`1px solid ${T.accent}30`,borderRadius:11,padding:"11px 16px",fontSize:12,color:T.accent,maxWidth:340}}>
            💡 <strong>Comment utiliser :</strong> Ouvrez une intervention → cliquez sur <strong>📋 PV d'intervention</strong> → le modèle s'ouvre automatiquement
          </div>
        )}
      </div>

      {/* VUE GRILLE */}
      {view==="grid" && (
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {TEMPLATES.map(tpl=>(
            <div key={tpl.id} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:15,overflow:"hidden",cursor:"pointer",transition:"border 0.2s"}}
              onMouseEnter={e=>e.currentTarget.style.borderColor=tpl.color}
              onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}
              onClick={()=>openDetail(tpl)}>
              <div style={{display:"flex",alignItems:"center",gap:16,padding:"20px 24px"}}>
                {/* Icône */}
                <div style={{width:56,height:56,borderRadius:14,background:`${tpl.color}20`,border:`2px solid ${tpl.color}40`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,flexShrink:0}}>
                  {tpl.icon}
                </div>
                {/* Info */}
                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:5,flexWrap:"wrap"}}>
                    <div style={{fontSize:18,fontWeight:800,color:T.text}}>{tpl.nom}</div>
                    <span style={{fontSize:11,fontWeight:700,color:tpl.color,background:`${tpl.color}18`,padding:"3px 10px",borderRadius:20}}>{tpl.type}</span>
                  </div>
                  <div style={{fontSize:13,color:T.muted,marginBottom:10}}>{tpl.description}</div>
                  {/* Sections preview */}
                  <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                    {tpl.sections.map(s=>(
                      <span key={s.titre} style={{fontSize:11,color:T.mutedL,background:T.bg,border:`1px solid ${T.border}`,padding:"2px 9px",borderRadius:20}}>
                        {s.titre}
                      </span>
                    ))}
                  </div>
                </div>
                {/* Stats */}
                <div style={{textAlign:"right",flexShrink:0}}>
                  <div style={{fontSize:28,fontWeight:800,color:tpl.color}}>{tpl.sections.length}</div>
                  <div style={{fontSize:11,color:T.muted}}>sections</div>
                  <div style={{fontSize:11,color:T.accent,marginTop:6,fontWeight:600}}>Voir le détail →</div>
                </div>
              </div>
            </div>
          ))}

          {/* Comment ça marche */}
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:15,padding:22,marginTop:4}}>
            <div style={{fontSize:15,fontWeight:700,color:T.text,marginBottom:16}}>📖 Fonctionnement des PV numériques</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
              {[
                {n:"1",ic:"🔧",t:"Créer une intervention",d:"Depuis le dashboard ou le menu Interventions"},
                {n:"2",ic:"👤",t:"Assigner au technicien",d:"Le technicien voit l'intervention dans son planning"},
                {n:"3",ic:"📋",t:"Remplir le PV",d:"Ouvrir l'intervention → PV → remplir toutes les sections"},
                {n:"4",ic:"✅",t:"Signer et clôturer",d:"Signatures obligatoires → intervention terminée automatiquement"},
              ].map(s=>(
                <div key={s.n} style={{background:T.bg,borderRadius:12,padding:"16px 14px",border:`1px solid ${T.border}`}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                    <div style={{width:24,height:24,borderRadius:"50%",background:T.accent,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:800,color:"#fff",flexShrink:0}}>{s.n}</div>
                    <span style={{fontSize:18}}>{s.ic}</span>
                  </div>
                  <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4}}>{s.t}</div>
                  <div style={{fontSize:11,color:T.muted,lineHeight:1.4}}>{s.d}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* VUE DÉTAIL */}
      {view==="detail" && selected && (
        <div style={{display:"flex",flexDirection:"column",gap:16}}>
          {/* Header template */}
          <div style={{background:T.card,border:`2px solid ${selected.color}40`,borderRadius:16,padding:24}}>
            <div style={{display:"flex",alignItems:"center",gap:16,marginBottom:16}}>
              <div style={{width:64,height:64,borderRadius:16,background:`${selected.color}20`,border:`2px solid ${selected.color}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:32}}>
                {selected.icon}
              </div>
              <div>
                <div style={{fontSize:22,fontWeight:800,color:T.text}}>{selected.nom}</div>
                <div style={{fontSize:13,color:selected.color,fontWeight:600,marginTop:3}}>{selected.type}</div>
                <div style={{fontSize:13,color:T.muted,marginTop:3}}>{selected.description}</div>
              </div>
            </div>
            <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
              <div style={{background:`${selected.color}15`,border:`1px solid ${selected.color}30`,borderRadius:10,padding:"10px 16px",textAlign:"center"}}>
                <div style={{fontSize:22,fontWeight:800,color:selected.color}}>{selected.sections.length}</div>
                <div style={{fontSize:11,color:T.muted}}>Sections</div>
              </div>
              <div style={{background:`${selected.color}15`,border:`1px solid ${selected.color}30`,borderRadius:10,padding:"10px 16px",textAlign:"center"}}>
                <div style={{fontSize:22,fontWeight:800,color:selected.color}}>{selected.sections.reduce((a,s)=>a+s.champs.length,0)}</div>
                <div style={{fontSize:11,color:T.muted}}>Champs</div>
              </div>
              <div style={{background:`${T.success}15`,border:`1px solid ${T.success}30`,borderRadius:10,padding:"10px 16px",textAlign:"center"}}>
                <div style={{fontSize:22,fontWeight:800,color:T.success}}>✓</div>
                <div style={{fontSize:11,color:T.muted}}>Signatures</div>
              </div>
              <div style={{background:`${T.warning}15`,border:`1px solid ${T.warning}30`,borderRadius:10,padding:"10px 16px",textAlign:"center"}}>
                <div style={{fontSize:22,fontWeight:800,color:T.warning}}>📷</div>
                <div style={{fontSize:11,color:T.muted}}>Photos obligatoires</div>
              </div>
            </div>
          </div>

          {/* Sections détaillées */}
          <div style={{fontSize:15,fontWeight:700,color:T.text}}>Structure du PV</div>
          {selected.sections.map((section, si)=>(
            <div key={si} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:13,overflow:"hidden"}}>
              <div style={{padding:"14px 18px",borderBottom:`1px solid ${T.border}`,background:T.bg,display:"flex",alignItems:"center",gap:12}}>
                <div style={{width:28,height:28,borderRadius:"50%",background:`${selected.color}20`,border:`1.5px solid ${selected.color}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:800,color:selected.color,flexShrink:0}}>
                  {si+1}
                </div>
                <div style={{fontSize:14,fontWeight:700,color:T.text}}>{section.titre}</div>
                <div style={{marginLeft:"auto",fontSize:11,color:T.muted,fontWeight:600}}>{section.champs.length} champ(s)</div>
              </div>
              <div style={{padding:"14px 18px"}}>
                <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                  {section.champs.map((champ,ci)=>(
                    <div key={ci} style={{fontSize:12,color:T.text,background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"6px 12px",display:"flex",alignItems:"center",gap:6}}>
                      {champ.includes("obligatoire")||champ.includes("Signature")||champ.includes("Photo")
                        ? <span style={{color:T.danger,fontWeight:700}}>*</span>
                        : <span style={{color:T.muted}}>○</span>}
                      {champ}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}

          {/* Footer */}
          <div style={{background:T.accentDim,border:`1px solid ${T.accent}30`,borderRadius:12,padding:18,display:"flex",alignItems:"center",gap:14}}>
            <span style={{fontSize:28}}>💡</span>
            <div>
              <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:4}}>Utiliser ce modèle</div>
              <div style={{fontSize:13,color:T.muted}}>
                Ce modèle s'ouvre automatiquement quand un technicien clique sur <strong style={{color:T.text}}>📋 PV d'intervention</strong> depuis une intervention. Les données client sont pré-remplies automatiquement.
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
